// All constants and static data for the NotFound feature
// See ARCHITECTURE_GUIDE.md for rules

export const NOT_FOUND_TITLE = '404';
export const NOT_FOUND_SUBTITLE = 'Page Not Found';
export const NOT_FOUND_MESSAGE = "The page you're looking for doesn't exist or has been moved.";
export const NOT_FOUND_ACTIONS = [
  {
    label: 'Go to Home',
    to: '/',
    className: 'not-found-home-button'
  },
  {
    label: 'Go to Dashboard',
    to: '/dashboard',
    className: 'not-found-dashboard-button'
  }
];
